import { css } from '@emotion/react';

import { tokens, IconButton } from '@hotjar/hotsauce';
import { useTippy } from '@hotjar/webapp/hooks/useTippy';

import { Dropdown, List, Item } from './Dropdown';

interface DownloadDropdownProps {
  onDownloadImage: () => void;
  onDownloadData: () => void;
  isDisabled?: boolean;
  disabledText?: string;
}

export const DownloadDropdownLegacy = ({
  onDownloadImage,
  onDownloadData,
  isDisabled,
  disabledText,
}: DownloadDropdownProps): JSX.Element => {
  const tippyInstance = useTippy();

  const handleDownloadImage = (): void => {
    onDownloadImage();
    tippyInstance.close();
  };

  const handleDownloadData = (): void => {
    onDownloadData();
    tippyInstance.close();
  };

  return (
    <Dropdown
      placement="bottom-end"
      onCreate={tippyInstance.set}
      isDisabled={isDisabled}
      trigger={
        <IconButton
          isDisabled={isDisabled}
          icon="download"
          kind="ghost"
          size="s"
          tooltipText={isDisabled && disabledText ? disabledText : 'Download'}
          css={css`
            margin-left: ${tokens.spacer.x0pt5};
          `}
        />
      }
    >
      <List>
        <Item title="Download JPG" subTitle="Image only" onClick={handleDownloadImage} />
        <Item title="Download CSV" subTitle="Raw heatmap data" onClick={handleDownloadData} />
      </List>
    </Dropdown>
  );
};
